<script setup lang="ts">
import { NarrowedPremium, PolicyType } from "@/entities/premium";
import PremiumLayout from "../PremiumLayout.vue";
import CompanyLogo from "../Shared/CompanyLogo.vue";
import PeriodicAmount from "../Shared/PeriodicAmount.vue";
import AnnualIncome from "../Shared/AnnualIncome.vue";
import { PaymentFrequency } from "@/stores/pensionOptions";
import Documents from "../Shared/Documents/Documents.vue";
import ProviderInformation from "../Shared/ProviderInformation.vue";
import MoreInfoButton from "../Shared/MoreInfoButton.vue";
import ProviderWarningBanner from "../Shared/ProviderWarningBanner.vue";
import { useConfigStore } from "@/stores/config";
import { STANDARD_LIFE_PROCESSING_DELAY_MESSAGE } from "@/constants/companyNames";

const config = useConfigStore();

defineProps<{
    premium: NarrowedPremium<PolicyType.Indicative>;
    paymentFrequency: PaymentFrequency;
    quoteNumber: string;
}>();
</script>

<template>
    <PremiumLayout :premium-id="premium.premiumId">
        <template #first>
            <CompanyLogo :company-slug="premium.company.slug" />
            <PeriodicAmount
                :total-annual-pension="premium.policy.totalAnnualPension"
                :frequency="paymentFrequency"
            />
        </template>
        <template #second>
            <PeriodicAmount
                v-if="paymentFrequency === PaymentFrequency.Yearly"
                :total-annual-pension="premium.policy.totalAnnualPension"
                :frequency="paymentFrequency"
            />
            <AnnualIncome
                v-else
                :total-annual-pension="premium.policy.totalAnnualPension"
            />
        </template>
        <template
            #cta="{
                moreInfoOpen,
                toggleMoreInfo
            }"
        >
            <MoreInfoButton
                :more-info-open="moreInfoOpen"
                :premium-id="premium.premiumId"
                @click="toggleMoreInfo"
            />
        </template>
        <template
            #tablet-cta="{
                moreInfoOpen,
                toggleMoreInfo
            }"
        >
            <MoreInfoButton
                :more-info-open="moreInfoOpen"
                :premium-id="premium.premiumId"
                @click="toggleMoreInfo"
            />
        </template>
        <template #more-info-banner>
            <ProviderWarningBanner
                v-if="config.standardLifeProcessingDelayBannerEnabled && premium.company.slug === 'sl'"
                :message="STANDARD_LIFE_PROCESSING_DELAY_MESSAGE"
            />
        </template>
        <template #more-info>
            <Documents
                :premium="premium"
                :quote-number="quoteNumber"
            />
            <div>
                <ProviderInformation :premium="premium" />
                <a
                    class="btn btn-indicative mt-2 mb-md-1"
                    href="tel:08003265479"
                >
                    Please call Annuity Ready on 0800 326 5479 to get a guaranteed quote
                </a>
            </div>
        </template>
    </PremiumLayout>
</template>
